// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","appLogo":"App_appLogo__jRe1A","appLogoSpin":"App_appLogoSpin__73C52","appHeader":"App_appHeader__1AEvo","appLink":"App_appLink__B+acO"};